import React, { ReactElement } from "react";

function IconTag({
  fill = "currentColor",
  height = 18,
  width = 18,
}: {
  fill?: string;
  height?: number;
  width?: number;
}): ReactElement {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#icon-tag-clip)">
        <path
          d="M17.3088 9.95458L10.3232 2.96507C9.95432 2.59618 9.46117 2.39038 8.94084 2.39038C8.89812 2.39038 8.85541 2.39038 8.8127 2.39426L3.76084 2.7282C3.21332 2.76315 2.77066 3.20582 2.73571 3.75333L2.61533 5.54731C2.35905 5.39975 2.11442 5.21336 1.89308 4.99203C1.35334 4.45228 1.0194 3.78051 0.9495 3.0971C0.883488 2.44862 1.06988 1.87005 1.47371 1.46621C2.33187 0.608054 3.91227 0.798324 5.00341 1.88558C5.18592 2.06808 5.48103 2.06808 5.66353 1.88558C5.84604 1.70308 5.84604 1.40796 5.66353 1.22546C4.2035 -0.222921 2.02899 -0.409307 0.80971 0.809973C0.203953 1.41573 -0.0756276 2.25835 0.0175659 3.19417C0.106876 4.09116 0.537896 4.96485 1.22908 5.65603C1.61739 6.04434 2.06782 6.3511 2.54544 6.56078L2.39788 8.80908C2.35905 9.37212 2.56874 9.92351 2.96869 10.3235L9.9582 17.313C10.4009 17.7556 10.9872 17.9964 11.6124 17.9964C12.2376 17.9964 12.8239 17.7518 13.2666 17.313L17.3166 13.2629C17.7593 12.8203 18 12.2339 18 11.6088C17.9961 10.9797 17.7515 10.3934 17.3088 9.95458ZM16.6526 12.5989L12.5987 16.6529C12.3346 16.9169 11.9813 17.0645 11.6046 17.0645C11.228 17.0645 10.8746 16.9169 10.6106 16.6529L3.62105 9.66335C3.41136 9.45366 3.30263 9.16632 3.32205 8.8712L3.45796 6.83648C3.53562 6.84813 3.61328 6.85978 3.69094 6.86755C3.80743 6.87919 3.92392 6.88696 4.03653 6.88696C4.83256 6.88696 5.54316 6.60738 6.07126 6.07929C6.25376 5.89678 6.25376 5.60167 6.07126 5.41916C5.88875 5.23666 5.59364 5.23666 5.41114 5.41916C5.0073 5.823 4.42872 6.00939 3.78025 5.94338C3.69094 5.93561 3.60551 5.92008 3.52009 5.90455L3.65988 3.82323C3.66376 3.7378 3.73365 3.67179 3.81908 3.66402L8.87094 3.33008C8.89424 3.33008 8.91754 3.3262 8.94084 3.3262C9.21265 3.3262 9.4767 3.43492 9.66697 3.62519L16.6526 10.6108C16.9166 10.8749 17.0642 11.2282 17.0642 11.6049C17.0642 11.9815 16.9166 12.3349 16.6526 12.5989Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="icon-tag-clip">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default IconTag;
